const convertStringNumberToInteger = (sameDayBookingConfig) => {
  for (const key in sameDayBookingConfig) {
    if (typeof sameDayBookingConfig[key] === 'string' && !isNaN(sameDayBookingConfig[key])) {
      sameDayBookingConfig[key] = +sameDayBookingConfig[key]
    }
  }
  if (sameDayBookingConfig.services && sameDayBookingConfig.services.length) {
    sameDayBookingConfig.services.forEach(service => {
      for (const key in service) {
        if (typeof service[key] === 'string' && !isNaN(service[key])) {
          service[key] = +service[key]
        }
      }
      if (service.provinces && service.provinces.length) {
        service.provinces.forEach(province => {
          for (const key in province) {
            if (typeof province[key] === 'string' && !isNaN(province[key])) {
              province[key] = +province[key]
            }
          }
        })
      }
    })
  }
  return sameDayBookingConfig
}

export default {
  formatSameDayData (sameDayBookingConfig) {
    sameDayBookingConfig = convertStringNumberToInteger(sameDayBookingConfig)
    return sameDayBookingConfig
  },
  getParentService (services, serviceId) {
    let parentServiceId = serviceId
    if (services[serviceId].parent_id > 0) {
      parentServiceId = services[serviceId].parent_id
    }
    let service = null
    for (let key in services) {
      const id = services[key].id
      if (id === parentServiceId) {
        service = services[key]
      }
    }
    return service
  },
  getServiceData (services, serviceId) {
    let service = null
    for (let key in services) {
      const id = services[key].id
      if (id === serviceId) {
        service = services[key]
      }
    }
    return service
  },
  getSameDayService (sameDayBookingConfig, serviceId, provinceId) {
    let sameDayService = sameDayBookingConfig
    const services = sameDayBookingConfig.services
    for (let service of services) {
      if (serviceId === service.service_id) {
        if (provinceId && service.provinces && service.provinces.length) {
          for (let province of service.provinces) {
            if (province.province_id === provinceId) {
              sameDayService = province
              break
            }
          }
        } else {
          sameDayService = service
        }
        break
      }
    }
    return sameDayService
  },
  getTotalPriceOfServiceItems (serviceItems) {
    let totalPrice = 0.0
    serviceItems.forEach(item => {
      if (item.cost) {
        const basePrice = item.cost * item.count
        if (item.discount_conditions) {
          const itemCount = item.count
          let hasDiscountCondition = false
          for (const discountCondition of item.discount_conditions) {
            if (itemCount === discountCondition.quantity) {
              hasDiscountCondition = true
              let discountCost = (basePrice * discountCondition.discount) / 100
              discountCost = Math.round(discountCost * 100) / 100
              totalPrice += basePrice - discountCost
              break
            }
          }
          if (!hasDiscountCondition) {
            totalPrice += basePrice
          }
        } else {
          totalPrice += basePrice
        }
      }
    })
    return totalPrice
  },
  getServiceItemDuration (count, serviceItem) {
    const durationConditions = serviceItem.duration_conditions
    if (durationConditions) {
      for (const durationCondition of durationConditions) {
        if (durationCondition.quantity === count) {
          return durationCondition.duration
        }
      }
    }
    return 0.0
  },
  converStringToNumber (value) {
    if (typeof value === 'string' && !isNaN(value)) {
      value = Number(value)
    }
    return value
  }
}



// WEBPACK FOOTER //
// ./src/helpers/serviceHelpers.js